/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
import api from '@src/api';

export const logout = () => api.get('user/logout', undefined, { skipAuthRefresh: true });

export const emailLogin = payload => api.post('user/login', payload);

export const emailRegister = payload => api.post('user', payload);

export const emailConfirm = payload => api.post('user/email/confirm', payload);

export const emailReSend = payload => api.post('user', payload);

export const updateMobile = payload => api.post('user/mobile', payload);

export const confirmMobile = payload => api.post('user/mobile/confirm', payload);

export const forgetPassword = payload => api.post('user/password/forgot', payload);

export const getForgetPasswordEmail = payload => api.get('user/password/forgot', payload);

export const resetPassword = payload => api.post('user/password/reset', payload);

export const verifyPassword = payload => api.post('user/password/verify', payload);

export const verifyIdNumber = payload => api.post('user/id-number/verify', payload);

export const socialLoginPrepare = ({ name }) => api.get(`ext/oauth/${name}/login`);

export const socialLogin = ({ name, params }) => api.get(`ext/oauth/${name}`, params);

export const oauthExchange = payload => api.post('ext/oauth/exchange', payload);

export const sendBugMsg = payload => api.post('ext/debug', payload);

export const rfaLogin = payload => api.post('user/rfa-login', undefined, { customHeader: { Authorization: payload.token } });

export const checkMobileLineBound = payload => api.post('user/mobile/line-bound', payload);

export const lineTokenLogin = payload => api.post('user/line-login', payload);

export const bindLine = payload => api.post('user/bind-line', payload);
